import { actionsFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { EventReminderWithSendAt, GetAdminEventRemindersParamsType, UpdateAdminEventReminderParamsType } from './types';
import * as keyWindowNames from './keyWindowNames';

export const getAdminEventReminders = actionsFactories.createGetManyActionsFactory<
  EntityType<EventReminderWithSendAt>,
  GetAdminEventRemindersParamsType
>()(
  'GET_ADMIN_EVENT_REMINDERS_REQUEST',
  'GET_ADMIN_EVENT_REMINDERS_SUCCESS',
  'GET_ADMIN_EVENT_REMINDERS_FAILURE',
  'GET_ADMIN_EVENT_REMINDERS_EMAILS_RESET',
  keyWindowNames.adminEventReminders,
);

export const runtimeUpdateAdminEventReminder = actionsFactories.createUpdateOneActionsFactory<
  EntityType<EventReminderWithSendAt>,
  UpdateAdminEventReminderParamsType
>()(
  'RUNTIME_UPDATE_ADMIN_EVENT_REMINDER_REQUEST',
  'RUNTIME_UPDATE_ADMIN_EVENT_REMINDER_SUCCESS',
  'RUNTIME_UPDATE_ADMIN_EVENT_REMINDER_FAILURE',
  'RUNTIME_UPDATE_ADMIN_EVENT_REMINDER_RESET',
);

export const createAdminEventReminder = actionsFactories.createCreateOneActionsFactory<
  EntityType<EventReminderWithSendAt>,
  GetAdminEventRemindersParamsType
>()(
  'CREATE_ADMIN_EVENT_REMINDER_REQUEST',
  'CREATE_ADMIN_EVENT_REMINDER_SUCCESS',
  'CREATE_ADMIN_EVENT_REMINDER_FAILURE',
  'CREATE_ADMIN_EVENT_REMINDER_RESET',
  keyWindowNames.adminEventReminders,
);

export const deleteAdminEventReminder =
  actionsFactories.createDeleteOneActionsFactory<GetAdminEventRemindersParamsType>()(
    'DELETE_ADMIN_EVENT_REMINDER_REQUEST',
    'DELETE_ADMIN_EVENT_REMINDER_SUCCESS',
    'DELETE_ADMIN_EVENT_REMINDER_FAILURE',
  );
